import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'pl', 'nl', 'cz', 'at', 'hu', 'fr', 'it', 'sk', 'ro'],
    load: 'languageOnly',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'cookie', 'navigator', 'htmlTag'],
      caches: ['cookie'],
      cookieMinutes: 525600,
    },
  });

function syncHtmlLang(lng: string | undefined): void {
  document.documentElement.lang = (lng || 'en').split('-')[0];
}

syncHtmlLang(i18n.resolvedLanguage || i18n.language);
i18n.on('initialized', () => syncHtmlLang(i18n.resolvedLanguage || i18n.language));
i18n.on('languageChanged', syncHtmlLang);

export default i18n;